import { ConvertImagePath } from '~/utils/functions/common'

const S3_PATH =
  process.env.S3_PATH_ENV === 'development' ? 'image.dev.synca.net' : `${process.env.S3_PATH}`

export const FormatSalaryType = (_jobOffer: { salary_type: string }) => {
  if (!_jobOffer || !_jobOffer.salary_type) return ''
  if (_jobOffer.salary_type === 'hourly_payment') return '時給'
  if (_jobOffer.salary_type === 'monthly_payment') return '月額'
  return '固定'
}

export const formatSalary = (_salaries: {
  max_salary: number | null
  min_salary: number | null
}) => {
  if (!_salaries) return ''
  const { max_salary, min_salary } = _salaries
  let formatSalary = ''

  if (max_salary && min_salary) {
    formatSalary = String(min_salary) + '万〜' + String(max_salary) + '万円'
  } else if (!max_salary && min_salary) {
    formatSalary = String(min_salary) + '万〜'
  } else if (!min_salary && max_salary) {
    formatSalary = '〜' + String(max_salary) + '万円'
  }

  return formatSalary
}

export const formatWorkStyle = (_work_style: string) => {
  /* 勤務形態を返す */
  if (!_work_style) return null
  if (_work_style === 'telecommute') {
    return 'フルリモート可'
  } else if (_work_style === 'telework') {
    return '週1～2日 リモート可'
  } else if (_work_style === 'attendance') {
    return '原則出社'
  } else if (_work_style === 'telework3_4') {
    return '週3～4日 リモート可'
  } else if (_work_style === 'office') {
    return '完全出社'
  } else {
    return null
  }
}

export const formatSideSalary = (
  _jobOffer: { max_salary: number; min_salary: number },
  _yenFlag: boolean = true
) => {
  if (!_jobOffer) return ''
  const { max_salary, min_salary } = _jobOffer || {}
  let formatSalary = ''
  // 円の有無
  const yen = _yenFlag ? '円' : ''

  if (max_salary && min_salary) {
    formatSalary = min_salary.toLocaleString() + '〜' + max_salary.toLocaleString() + yen
  } else if (!max_salary && min_salary) {
    formatSalary = min_salary.toLocaleString() + yen
  } else if (!min_salary && max_salary) {
    formatSalary = '〜' + max_salary.toLocaleString() + yen
  }

  return formatSalary
}

// TRY 勤務形態
export const formatSideWorkStyle = (_work_style: string) => {
  if (_work_style === 'office_work') {
    return '主に出社'
  } else if (_work_style === 'partly_remote_work') {
    return '一部テレワーク'
  } else if (_work_style === 'full_remote_work') {
    return '完全テレワーク'
  } else {
    return '規定なし（応相談）'
  }
}

export const formatJobofferOriginalImg = (_img: string, _size: number = 0.8) => {
  if (!_img) return ''
  return ConvertImagePath(`https://${S3_PATH}/slides/original_${_img}`, _size)
}

export const formatJobofferOriginalImgPath = (_img: string) => {
  if (!_img) return ''
  return `https://${S3_PATH}/slides/original_${_img}`
}
